import { Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';

import {
	Owner,
	RestService,
	IS_NOT_NULL_OR_UNDEFINED,
	USERS_LIST_FOR_POPOVER,
} from 'cargo-chief-commons';

import { UtilService } from '@service/util/util.service';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { UrlService } from '@service/url/url.service';
import { ACCOUNT_STATUS } from '@domain/constants/app-variables';

import { User } from '@domain/interface/user';
import { MtxPopoverTrigger } from '@ng-matero/extensions/popover';

@Component({
	selector: 'app-user-popover',
	templateUrl: './user-popover.component.html',
	styleUrls: ['./user-popover.component.scss'],
})
export class UserPopoverComponent implements OnInit {
	@Input() isEnabled: boolean = false;
	@Input() multiselect: boolean = false;
	@Input() singleselect: boolean = false;
	@Input() usersList: Array<Owner> = [];
	@Input() selectedUsers = [];
	@Input() placeholder: string = 'Assign User';
	@Input() showAssignMe: boolean = false;
	@Input() assignText: string = 'Assign To Me';
	@Input() showAssignMeBelowInput: boolean = false;
	@Input() showAssignMeOnRight: boolean = false;
	@Input() customAssignTexClass: string = '';
	@Input() customFormFieldClass: string = '';

	@Output() userChanged: EventEmitter<any> = new EventEmitter();

	@ViewChild(MtxPopoverTrigger) trigger: MtxPopoverTrigger;

	searchText;
	isLoadingUsersList: boolean = false;
	CURRENT_PAGE = 0;
	PAGE_SIZE = 50;
	renderUserPopover: boolean = false;

	constructor(
		private restService: RestService,
		private urlService: UrlService,
		public utilService: UtilService,
		private cargochief: Cargochief,
		private _ngZone: NgZone
	) {}

	ngOnInit() {
		if (
			this.isEnabled &&
			(this.utilService.isNullOrUndefined(this.usersList) || this.usersList.length == 0)
		) {
			this.getUsersListForAccount();
			this.renderUserPopover = true;
		} else {
			this._ngZone.runOutsideAngular(() => {
				this.initializePlaceholder();
				this.renderUserPopover = true;
			});
		}
	}

	userClicked(user: Owner) {
		if (this.singleselect) {
			this.selectedUsers = [];
			this.usersList = this.usersList.map((userModel: Owner) => {
				if (userModel.userId != user.userId) {
					userModel.selected = false;
				}
				return userModel;
			});
			if (user.selected) {
				this.selectedUsers.push(user.userId);
				this.userChanged.emit(user);
				this.closePopover();
				this.placeholder = user.name;
			} else {
				this.placeholder = '';
				this.userChanged.emit(null);
			}
		} else if (this.multiselect) {
			this.userChanged.emit(this.selectedUsers);
		}
	}

	setCurrentUser() {
		let user: Owner = this.usersList.filter((userModel: Owner) => {
			return userModel.userId == this.cargochief.USER_ID;
		})[0];
		if (!this.utilService.isNullOrUndefined(user)) {
			user.selected = true;
			this.userClicked(user);
		}
	}

	closePopover() {
		if (!this.utilService.isNullOrUndefined(this.trigger) && this.singleselect) {
			this.trigger.closePopover();
		}
	}

	getUsersListForAccount() {
		this.usersList = null;
		this.isLoadingUsersList = true;
		const url = this.urlService.getActiveUsersByAccountIdUrl(
			this.cargochief.ACCOUNT_ID,
			this.CURRENT_PAGE,
			this.PAGE_SIZE
		);
		this.restService.GET(url).subscribe(
			(response) => {
				this.usersList = [];
				this.usersList = USERS_LIST_FOR_POPOVER({
					users: response.data,
					assigneeId: null,
					removeHavingStatus: ACCOUNT_STATUS.INACTIVE,
				});
				this.usersList = [].concat(
					this.usersList.map((user) => {
						user.selected = false;
						return Object.assign({}, user);
					})
				);
				this.initializePlaceholder();
				this.isLoadingUsersList = false;
			},
			(error) => {
				this.isLoadingUsersList = false;
			}
		);
	}

	initializePlaceholder() {
		if (this.selectedUsers?.length > 0 && this.usersList?.length) {
			this.usersList = this.usersList.filter((user) => {
				if (this.selectedUsers.indexOf(user.userId) > -1) {
					this.placeholder = user.name + ' ';
					user.selected = true;
				}
				return user;
			});
		}
	}
}
